module.exports = __webpack_public_path__ + "static/media/camera.55516532.jpeg";